import {VRating} from 'vuetify/lib'
import VForm from '@/vuetify_custom/v-form'
import VModel from '@/vuetify_custom/v-modal_v1'
import IntegerField from '@/vuetify_custom/v-form/components/Integer_Field.js'
import AutocompletesAsyncS from '@/vuetify_custom/v-form/components/Autocompletes_Async_v2.js'
import AutocompletesAsync from '@/vuetify_custom/v-form/components/Autocompletes_Async_v1.js'
import EditAttachments from '@/views/components/file/edit_attachments_v1'
import FileUploader from '@/views/components/file/uploader.vue'
import IsSampleTip from '@/vuetify_custom/IsSampleTip.vue'
import {allHaveOrNot} from '@/views/blogger/records/utils.js'
import {put_in_types, publish_form_list} from '../../fields'
import { postPlacingAdsRecordSaveApi, getPlacingAdsRecordDetailApi } from '../service'
import {getEnumConfigListApi} from '@/views/blogger/sku/service.js'
import styles from '../style.module.less'
const i_v = ['', null, undefined]
const needs_arr = ['placing_ads_url', 'publish_at', 'payable_price']
function createFirstWeekEffect() {
    return {
        like_num:null,
        comment_num:null,
        favorite_num:null,
        view_num:null,
    }
}
function createAmountEffect() {
    return {
        like_num:null,
        comment_num:null,
        favorite_num:null,
        view_num:null,
    }
}
function createParams() {
    return {
        id:null,
        kol_id:null,
        tags: null,
        placing_type:null,
        cooperation_type:null,
        estimate_publish_at:null,
        publish_at:null,
        accounting_at: null,
        publish_form:null,
        sku_id:null,
        team_id:null,
        total_price:null,
        placing_ads_url:null,
        delayed:null,
        attitude_rating:null,
        content_rating:null,
        other_evaluation:null,
        remark:null,
        contract_type:null,
        contract_id: null,
        bfiles: [],
        payee_account: '',
        payee_name: '',
        payable_price: null,
        persona: null,
        publish_situations: [],
        first_week_effect: createFirstWeekEffect(),
        amount_effect:createAmountEffect()
    }
}

const NumberContain = {
    props: {
        value: {
            type: Object
        },
        rules: {
            type:Array
        },
        disabled: {
            type: Boolean
        }
    },
    data() {
        return {
            val: this.value,
            contract_items: [],
            out_contract_items:[],
        }
    },
    watch: {
        value(val) {
            this.val = val
        },
        val(val) {
            this.$emit('input', val)
        }
    },
    computed: {
    
        rulesProxy() {
            const rules = this.rules || []
            return rules.concat([val => {
                if (i_v.includes(val)) {
                    return true
                }
                return val >= 0 || '不能为负数'
            }])
        }
    },
    render() {
        return <div>
        <IntegerField 
            v-model={this.val}
            field = {{
                    disabled: this.disabled,
                    key: 'like_num',
                    label: '点赞数',
                    required: !! this.rules,
                    rules: this.rulesProxy
                }}/>
    
        <IntegerField 
            v-model={this.val}
            field = {{
                    disabled: this.disabled,
                    key: 'favorite_num',
                    label: '收藏数',
                    required: !! this.rules,
                    rules: this.rulesProxy
                }}/>
                    <IntegerField 
            v-model={this.val}
            field = {{
                    disabled: this.disabled,
                    key: 'comment_num',
                    label: '评论数',
                    required: !! this.rules,
                    rules: this.rulesProxy
                }}/>
        <IntegerField 
            v-model={this.val}
            field = {{
                    disabled: this.disabled,
                    key: 'view_num',
                    label: '播放数',
                    required: !! this.rules,
                    rules: this.rulesProxy
                }}/>
    </div>
    }
}


export default {
    props: {
        isFin: {
            type:Boolean
        }
    },
    data() {
        return {
            dis: false,
            submitLoading: false,
            params:createParams(),
            contract_items: [],
            out_contract_items: [],
            has_contract: false,
            has_fk: false,
            has_zd: false,
            consume_equal_total: false,
            cooperation_type_list: [],
            content_types: [],
            people_portrait_list: [],
            fieldsFilter: null,
            paramsFilter: null
        }
    },
    computed: {
        cur_customer() {
           
            return this.$store.state.cur_customer;
        },
        contract_api_hash() {
            return {
                Contract: this.$util.api.contract_select_search,
                OutsourceContract:this.$util.api.outsource_contract_select_search,
            }
        },
        baseInforFields() {
           const d = [(val) => ![undefined, null, ''].includes(val) || '必选']
           const _this = this
           let api = null
           let handle_data_proxy = null
           let contract_field = null
           
            let arr = [
                {
                    label: 'kol',
                    key: 'kol_id',
                    // initList: this.defaultApply,
                    // out_params: {
                    //     formal: true,
                    // },
                    disabled: !this.isFin && !!this.params.id,
                    type:'autocompletes_async_v1',
                    'item-value':'id',
                    'item-text':'dis_text',
                    api: this.$util.api.placing_ads_kol_list,
                
                    cols:12,
                    required: true,
                
                    rules: d,
                    handle_data:a => {
                        if (!a) {
                            return []
                        }
                   
                        return a.map(i => ({
                            ...i,
                            dis_text: `${i.platform_nickname}/${i.uid}/${i.tags}/${i.platform}/${i.platform_account}/${i.wechat_account}/${i.phone_number}`
                        })) 
                    },
                    item_slot: (h, i) => {
                       return <div style="margin:5px;">
                           <p class={styles['item-name']}>{i.platform_nickname}{!!i.is_risk && <span class="color-error">[风险博主]</span>}</p>
                           <p class={styles['item-o']}>uid：{i.uid}</p>
                           <p class={styles['item-o']}>平台：{i.platform}</p>
                           <p class={styles['item-o']}>平台账号：{i.platform_account}</p>
                           {/* <p class={styles['item-o']}>微信：{i.wechat_account}</p>
                           <p class={styles['item-o']}>电话号码：{i.phone_number}</p> */}
                       </div>
                   }
                },
       
               {
                label: '投放类型',
                type: 'select_field',
                key: 'placing_type',
                'item-text': 'label',
                'item-value': 'value',
                cols: 8,
                disabled: this.has_zd || this.has_fk,
                required: true,
                items:put_in_types,
                rules: d,
                change: (val) => {
                    if (val !== 'simple_payment') {
                        this.params.payee_account = ''
                        this.params.payee_name = ''
                    }
                 }
               },
               {
                label: '人群画像',
                type: 'autocompletes',
                key: 'persona',
                'item-text': 'enum_value',
                'item-value': 'enum_value',
                required: true,
                rules: d,
                cols: 8,
                items:this.people_portrait_list,
            },
                {
                    label: '内容类别',
                    key:'tags',
                    type:'autocompletes',
                    multiple: true,
                    'item-text': 'enum_value',
                    'item-value': 'enum_value',
                    items: this.content_types,
                    required: true,
                    cols: 8,
                    rules: [val => {
                        return !!(val && val.length) || '必选'
                    }]
                },
                {
                    label: '发布情况',
                    type: 'select_field',
                    key: 'publish_situations',
                    'item-text': 'title',
                    'item-value': 'title',
                    clearable: true,
                    multiple: true,
                    cols: 8,
                    items:[
                        {
                            title: '限流',
                        },
                        {
                            title: '重发',
                        },
                        {
                            title: '修改',
                        }
                    ],
                },
               {
                label: '合作类型',
                type: 'select_field',
                key: 'cooperation_type',
                'item-text': 'enum_value',
                'item-value': 'enum_value',
                cols: 8,
                required: true,
                disabled: !this.isFin && this.has_fk,
                items:this.cooperation_type_list,
                rules: d,
               },
               {
                label: '预计投放时间',
                type: 'date_picker_v1',
                key: 'estimate_publish_at',
                cols: 8,
                rules: d,
                disabled: this.has_zd,
                required: true,
               },
               {
                label: '发布时间',
                type: 'date_picker_v1',
                key: 'publish_at',
                clearable: true,
                cols: 8,
                // rules: d,
                rules: [() => allHaveOrNot(needs_arr, this.params) || '投放链接、发布时间、发布金额应同时填写或者均不填写'],
                disabled: this.consume_equal_total,
                // required: true,
                change:(val) => {
                    if (this.isFin && !this.params.accounting_at) {
                        this.params.accounting_at = val
                    }
                }
               },
               {
                label: '入账时间',
                type: 'date_picker_v1',
                key: 'accounting_at',
                cols: 8,
                clearable: true,
                show: this.isFin
                // rules: d,
                // disabled: this.has_zd,
                //  required: true,
               },
               {
                label: '发布形式',
                type: 'select_field',
                key: 'publish_form',
                'item-text': 'label',
                'item-value': 'value',
                disabled: this.has_contract || this.has_fk || this.has_zd,
                cols: 8,
                items:publish_form_list,
                rules: d,
                required: true,
               },
               {
                label: '投放SKU',
                key:'sku_id',
                // initList: this.defaultApply,
                // out_params: {
                //     formal: true,
                // },
                type:'autocompletes_async_v1',
                'item-value':'id',
                'item-text':'full_name',
                disabled: this.has_zd,
                api: this.$util.api.placing_ads_sku_list,
                'item-disabled': (t) => {
                   return t.del
                },  
                cols:8,
                required: true,
                rules: d,
               //  rules: [commonValidateRuleGo],
                handle_data:a => a.filter(i => !i.del),
            
               },
               {
                label: '团队',
                type: 'team_select',
                key: 'team_id',
                // required: true,
                cols: 8,
              //   rules: d,
                disabled: true,
               },
               {
                label: '合同类型',
                type: 'select_field',
                key: 'contract_type',
                'item-text': 'label',
                'item-value': 'value',
                disabled: this.has_contract || this.has_fk || this.has_zd,
                cols: 8,
                clearable: true,
                items:[
                    {
                        label: '普通合同',
                        value: 'Contract'
                    },
                    {
                        label: '兼职外包合同',
                        value: 'OutsourceContract'
                    },
                ],
                onmousewheel: (val) => {
                      if (!val) {
                        this.params.contract_id = null
                      }
                }
                },
                {
                    key:'contract_id',
                },
               {
                label: '预计投放金额',
                type: 'number_field',
                key: 'total_price',
                required: true,
                cols: 8,
                d_digits:2,
                disabled: this.has_contract || this.has_fk || this.has_zd,
                rules: [...d, v => Number(v) >= 0 || '必须为非负数'],
                // keydown: () => {
                //     console.log('测试')
                // }
               },
               {
                label: '实际消耗',
                type: 'number_field',
                key: 'payable_price',
 
                cols: 8,
                d_digits:2,
                disabled: this.consume_equal_total,
                rules: [ () => allHaveOrNot(needs_arr, this.params) || '投放链接、发布时间、发布金额应同时填写或者均不填写', v => {
                    if (i_v.includes(v) || Number(v) === 0) {
                        return true
                    }
                  return Number(v) >= 0 || '必须为正数或0'
                }, (val) => {
                    if (Number(val) > 0 && Number(val) > Number(this.params.total_price)) {
                        return '实际消耗应小于等于预计投入金额'
                    }
                    return true
                }],
               },
               {
                label: '投放链接',
                key: 'placing_ads_url',
               //  required: true,
                cols: 8,
                // rules: d,
                rules: [() => allHaveOrNot(needs_arr, this.params) || '投放链接、发布时间、发布金额应同时填写或者均不填写'],
                disabled: this.consume_equal_total,
               },
               {
                   // show: true,
                    cols:8,
                    key: 'upload'
                },
                // {
                //     key: 'rating',
                //     cols: 8,
                // },
               {
                label: '评价-是否拖稿',
                type: 'checkbox',
                key: 'delayed',
                //   disabled: this.has_zd,
                cols: 8,
               },
               {
                key: 'attitude_rating',
                cols: 8,
               },
               {
                key: 'content_rating',
                cols: 8,
               },
               {
                label: '其他-评价',
                type: 'textareas_field',
                key: 'other_evaluation',
                disabled: this.has_zd,
                cols: 8,
                rows: 3,
               },
               {
                label: '备注',
                type: 'textareas_field',
                key: 'remark',
                cols: 8,
                rows: 3,
               },
               {
                   key:'first_week_effect',
                   cols: 8,
               },
               {
                    key:'amount_effect',
                    cols: 8,
               }
            ]
            if (this.params.placing_type === 'simple_payment') {
                arr = [...arr.slice(0, 2), 
                    {
                        label: '博主收款账号',
                        key: 'payee_account',
                        cols: 8,
                        required: true,
                        rules: d,
                        disabled: this.has_zd || this.has_fk,
                        scopedSlots: {
                            label: () => {
                                return <div>
                                <span ><span style="color:red">*</span>博主收款账号<span><IsSampleTip
                                    icon="mdi-help-circle-outline"
                                    content="请正确填写支付宝账号或者银行卡账号，如果填写银行卡账号则需一并填写开户行（例：62200000000 XX银行XX支行）"
                                /></span></span>
                                
                            </div>
                            } 
                        },
                    },
                    {
                        label: '博主收款姓名',
                        key: 'payee_name',
                        cols: 8,
                        required: true,
                        rules: d,
                        disabled: this.has_zd || this.has_fk,
                    }, 
                    ...arr.slice(2)]
            }
            switch (this.params.contract_type) {
                case 'Contract':
                case 'OutsourceContract':
                
                     api = this.contract_api_hash[this.params.contract_type]
                     handle_data_proxy = ((type) => (contracts) => {
                       return _this.contractItemsChange(contracts, type)
                    })(this.params.contract_type)
                    contract_field = {
                        label: '关联合同',
                        key:'contract_id',
                        type:'autocompletes_async_v1',
                        'item-value':'id',
                        'item-text':'uid_name',
                        disabled: this.has_contract || this.has_fk || this.has_zd,
                        out_params: {
                           //  payment_purpose: _this.params.payment_purpose
                           //   team_id: _this.params.team_id
                        },
                        api,
                        // init_list: [], // this.apply_user_list,
                        cols: 8,
                        required: true,
                        rules: [],
                        items: this.params.contract_type === 'Contract' ? this.contract_items : this.out_contract_items,
                        
                        handle_data:({contracts = []} = {}) => {
                            handle_data_proxy(contracts)
                        },
                        // change: (_, target = {}) => {
                        //  //  _this.changeContract(target)
                        // },
                    }
                    arr = arr.map(i => {
                        if (i.key === 'contract_id') {
                            return contract_field
                        }
                        return i
                    })
                   // arr = [...arr.slice(0, 9), contract_field, ...arr.slice(9)]
                    break;
                default:
                    arr = arr.filter(i => {
                        if (i.key === 'contract_id') {
                          return false
                        }
                        return true
                    })
                    break;
            }
             arr = arr.filter(i => {
                if (i.show === undefined) {
                    return true
                }
                return i.show
            }) 
            arr = this.fieldsFilter ? this.fieldsFilter(arr) : arr
            return arr
        },
        is_uda() {
            return this.cur_customer.groups && this.cur_customer.groups.includes('UDA_USER_GROUP');
        },
    },
    created() {
        this.cur_customer
        this.getEnumConfigHZList()
        this.getEnumConfigNRList()
        this.getPeoplePortraitList() 
    },
    methods: {
        getPeoplePortraitList() {
            getEnumConfigListApi({ 
                enum_type:'人群画像' + (this.is_uda ? '_UDA' : ''),
                del:false}).then(res => {
                    this.people_portrait_list = (res || [])
                    
            })
        },
        getEnumConfigNRList() {
            getEnumConfigListApi({ 
                enum_type:'内容类别' + (this.is_uda ? '_UDA' : ''),
                del:false}).then(res => {
                    this.content_types = (res || [])
                    
            })
        },
        getEnumConfigHZList() {
            getEnumConfigListApi({ 
                enum_type:'合作类型',
                del:false}).then(res => {
                    this.cooperation_type_list = (res || [])
                    
            })
        },

        resetValidation() {
            return this.$refs.base && this.$refs.base.resetValidation && this.$refs.base.resetValidation()
        },
        contractItemsChange(contracts, type) {
            const change_contract_items = type === 'Contract' ? this.contract_items : this.out_contract_items
            const items_hash = change_contract_items.reduce((t, i) => {
                t[i.id] = true
                return t
            }, {})
            contracts = contracts || []
            contracts.forEach(i => {
                if (!items_hash[i.id]) {
                    change_contract_items.push({
                        ...i,
                        uid_name: `${i.uid}-${i.name || i.account}`
                    })
                }
            });
         
        },
        initEditParams(params, {is_copy = false} = {}) {
                    
                if (is_copy || this.isFin) {
                    this.has_contract = false
                    this.has_fk = false
                    this.has_zd = false
                    this.consume_equal_total = false
                } else {
                    this.has_contract = false// !!params.placing_ads_contract
                    this.has_fk = params.expense_groups_fk && !!params.expense_groups_fk.length || false
                    this.has_zd = params.expense_groups_zd && !!params.expense_groups_zd.length || false
                      // 编辑的状态下，
                    if (!is_copy && 
                        params.id && 
                        !!Number(params.consume_price) &&
                        Number(params.consume_price) === Number(params.total_price)) {
                            this.consume_equal_total = true
                    }
                }
              
                const clone_params = this.params
                Object.keys(clone_params).forEach(key => {
                    clone_params[key] = params[key]
                })
                clone_params.tags = clone_params.tags && clone_params.tags.split(',') || []
                this.params = clone_params
                const {contract_id, contract_uid, contract_name, contract_type} = params.placing_ads_contract || {}
                this.params.contract_type = contract_type
              
                let current_types = [
                   
                ]
                if (contract_type) {
                    current_types = [
                        {
                            id:contract_id,
                            uid: contract_uid,
                            uid_name:`${contract_uid}-${contract_name}`,
                        }
                    ]
                }
             
                this.params.contract_id = contract_id
             
             
                if (this.params.contract_type === 'Contract') {
                    this.contract_items = current_types
                } else {
                    this.out_contract_items = current_types
                }
                if (params.publish_situations && params.publish_situations.split) {
                    this.params.publish_situations = params.publish_situations.split(',')
                }

                this.params.first_week_effect = this.params.first_week_effect || createFirstWeekEffect()
                this.params.amount_effect = this.params.amount_effect || createAmountEffect()
             
        },
        copy(params) {
            const c_p = createParams()
            this.dis = true
            this.params = createParams()
            this.has_contract = false
            this.has_fk = false
            this.has_zd = false
    
            if (params) {
                getPlacingAdsRecordDetailApi({id:params.id}).then(res => {
                    this.initEditParams(res, {is_copy:true})
                    this.params.id = null
              
                    // this.baseInforFields.forEach(i => {
                    //     if (!i.required && !!this.params[i.key]) {
                    //         this.params[i.key] = c_p[i.key]
                    //     }
                    // })
                    // console.log('this.params.contract_type', this.params.contract_type)
                })
                setTimeout(() => {
                    this.params.team_id = this.cur_customer.root_team_id
                }, 1000)
            } else {
                setTimeout(() => {
                    this.params.team_id = this.cur_customer.root_team_id
                }, 1000)
            }
        },
        edit(params, {
            fieldsFilter,
            paramsFilter
        } = {}) {
            this.fieldsFilter = fieldsFilter
            this.paramsFilter = paramsFilter
            this.dis = true
            this.params = createParams()
            this.has_contract = false
            this.has_fk = false
            this.has_zd = false
            this.consume_equal_total = false
            if (params) {
                getPlacingAdsRecordDetailApi({id:params.id}).then(res => {
                    this.initEditParams(res)
                })
            } else {
                setTimeout(() => {
                    this.params.team_id = this.cur_customer.root_team_id
                }, 1000)
            }
        },
        submit() {
            if (!(this.$refs.base && this.$refs.base.validate && this.$refs.base.validate())) {
                return
            }
            this.submitLoading = true
            const { team_id, tags, publish_situations, ...other_params} = JSON.parse(JSON.stringify((this.params || {}))) 
            other_params.tags = (tags || []).join(',')
            other_params.publish_situations = (publish_situations || []).join(',')
            const params = this.paramsFilter ? this.paramsFilter(other_params) : other_params
            
            postPlacingAdsRecordSaveApi(params).then(() => {
                setTimeout(() => {
                    this.$emit('success')
                }, 200)
                this.dis = false
                this.$Message.success('保存成功！')
            }).finally(() => {
                this.submitLoading = false
            })
        }
    },
    render() {
        return <VModel
        v-model={this.dis}
        persistent
        dynamic-height
        title={this.params.id ? '编辑' : '新增'}
        max-width="800"
        loading={this.submitLoading}
        on={{
             ok: this.submit,
            cancel:  this.resetValidation
        }}
       
    >
        <VForm
            ref="base"
            v-model={this.params}
            fields={this.baseInforFields}
            scopedSlots={{
                kol_id: ({field, value}) => {
                    return <AutocompletesAsync 
                    field={field} v-model={value}/>
                },
                sku_id:({field, value}) => {
                    return <AutocompletesAsync 
                        field={field} 
                        v-model={value}/>
                },
                rating: () => {
                    return <div>

                    </div>
                },
                attitude_rating:() => {
                    return <div>
                        评价-合作态度 ：<VRating 
                           //  readonly={this.has_zd}
                            v-model={this.params.attitude_rating} 
                            style="display:inline-block" />
                    </div>
                },
                content_rating:() => {
                    return <div>
                    评价-内容创造能力 ：<VRating v-model={this.params.content_rating} style="display:inline-block" />
                    </div>
                },
                first_week_effect:() => {
                    return <div class={styles.contain}>
                        <p>7 天效果：</p>
                        <NumberContain 
                            v-model={this.params.first_week_effect}
                            // disabled={this.has_zd}
                            // rules={[val => {
                            //     if ([undefined, null, ''].includes(val)) {
                            //         return '必填'
                            //     }
                            //     return true
                            // }]}
                        />
                    </div>
                },
                amount_effect:() => {
                    return <div class={styles.contain}>
                        <p>累计效果：</p>
                        <NumberContain v-model={this.params.amount_effect}/>
                    </div>
                },
                contract_id:({field}) => {
                    return <AutocompletesAsyncS
                    v-model={this.params}
                    field={field}
                />
            },
                upload:() => {
                    return <div style="display:flex">
                        <p style="width:40px">
                            附件
                        </p>
                        <div style="flex:1">
                            <EditAttachments
                                files={ this.params.bfiles}
                                    modelType="PlacingAdsRecord"
                                    modelId={this.params.id}
                                />
                                <FileUploader 
                                    validateFile={(file) => {
                                        const a = /\.[0-9a-zA-Z]+$/.test(file.name)
                                        if (!a) {
                                            this.$vModal.warning({
                                                title:'提示',
                                                content:'文件格式错误，无法解析。建议上传如下类型：.xlsx、.pdf等带有后缀的'
                                            })
                                        }
                                        return a
                                    }}
                                     on={{
                                    uploaded: (bfile) => {
                                        this.params.bfiles.push(bfile)
                                    },
                                }}/>
                                <span class="color-error">为保证兼容性及文档可编辑性，请上传office系列的文档(Word, Excel, PPT)或图片（jpg，png）。</span>
                        </div>
                    </div>
                },
            }}
        />
        {/* attitude_rating */}
        </VModel>
    }
}